export function testCAEPF(value: string | number): boolean {
    const caepf = String(value).replace(/[^0-9]*/g, "");

    if (caepf.length !== 14) {
        return false;
    }

    const caepfBase = caepf.slice(0, 12);

    const digitosReverse = [...caepfBase]
        .reverse()
        .reduce<number[]>((previousValue, currentValue) => {
            previousValue.push(Number(currentValue));
            return previousValue;
        }, []);

    const calcModuleDV = (array: number[], nModuleInit = 9, nModuleMin = 2) => {
        let nModule = 9;
        let result = 0;
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            result += element * nModule;
            nModule > nModuleMin ? (nModule = nModule - 1) : (nModule = nModuleInit);
        }
        result = result % 11;
        if (result === 10) {
            result = 0;
        }
        return result;
    };
    const firstDigitDV = calcModuleDV(digitosReverse);
    const lastDigitDV = calcModuleDV([firstDigitDV].concat(digitosReverse));

    let resultDV = firstDigitDV * 10 + lastDigitDV + 12;
    if (resultDV > 99) {
        resultDV = resultDV - 100;
    }
    let resultDVString: string = "";

    if (resultDV == 0) {
        resultDVString = "00";
    } else if (resultDV > 0 && resultDV < 10) {
        resultDVString = `0${resultDV}`;
    } else {
        resultDVString = String(resultDV);
    }

    const validCAEPF = `${caepfBase}${resultDVString}`;
    return caepf === validCAEPF ? true : false;
}